import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProductRequirement from '../views/ProductRequirement.vue'
import CompareProduct from '../views/CompareProduct.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter:(to, from, next)=>{
      // 多语言
      fetch(`${process.env.VUE_APP_BASE_API}/API/Product/GetAllFrontEndMultiLanguages`,{
        method: 'GET',
        headers: {  
          'Accept':'application/json',
          'Content-Type': 'application/json',  
        }
      })
      .then(res=>res.text())
      .then(res => {
        const jsonObject = JSON.parse(res);
        if(jsonObject.code==200){
          window.localStorage.setItem("lan",JSON.stringify(jsonObject.data));
        }

        //权限
        const userInfoJson = window.localStorage.getItem("userInfo");
        let userID = "";
        if(userInfoJson){
            userID = JSON.parse(userInfoJson).ID;
        }
        fetch(`${process.env.VUE_APP_BASE_API}/API/FrontEndUser/GetPermissionCodes?userID=${userID}`,{
          method: 'GET',
          headers: {  
            'Accept':'application/json',
            'Content-Type': 'application/json',  
          }
        })
        .then(res=>res.text())
        .then(res => {
          const jsonObject = JSON.parse(res);
          if(jsonObject.code==200){
            window.localStorage.setItem("PermissionCodes",JSON.stringify(jsonObject.data));
          }else{
            window.localStorage.setItem("PermissionCodes",JSON.stringify([]));
          }
            //品牌装修
            fetch(`${process.env.VUE_APP_BASE_API}/API/Product/GetAllBrandDecorations`,{
              method: 'GET',
              headers: {  
                'Accept':'application/json',
                'Content-Type': 'application/json',  
              }
            })
            .then(res=>res.text())
            .then(res => {
              const jsonObject = JSON.parse(res);
              if(jsonObject.code==200){
                window.localStorage.setItem("brandDecorations",JSON.stringify(jsonObject.data));
              }
              next();
            });
        }); 
      });
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/productRequirement', //产品需求页面
    name: 'productRequirement',
    component: ProductRequirement
  },
  {
    path: '/compareProduct', //产品对比页面
    name: 'compareProduct',
    component: CompareProduct
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
